"use strict";

var _productOrEditionHomepageUrl = require("./productOrEditionHomepageUrl");

var _entitledToViewHomePage = _interopRequireDefault(require("./entitledToViewHomePage"));

var _collections = require("./collections");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var addDisplayName = function addDisplayName(item) {
  return Object.assign({
    displayName: item.name
  }, item);
};

var hideOnSmallViewports = function hideOnSmallViewports(item) {
  return Object.assign({
    hideOnSmallViewports: true
  }, item);
};

var sort = function sort(productOrEditionHomepageUrls) {
  var result = productOrEditionHomepageUrls.sort(function (editionA, editionB) {
    return editionA.position - editionB.position;
  });
  result.forEach(function (edition) {
    return delete edition.position;
  });
  return result;
};

module.exports = function debtwireNavigationLinks(editions, env, subscriptionTagIds) {
  var homepageLink = {
    link: '/homepage',
    position: 5,
    name: 'Home'
  };
  var companyDirectory = {
    link: '/companies',
    position: 20,
    name: 'Company Directory'
  };

  var topicsLink = function topicsLink(editions) {
    return (0, _entitledToViewHomePage["default"])(editions) ? {
      link: '/topics',
      name: 'Topics',
      position: 110
    } : [];
  };

  var xtractResearch = {
    link: 'https://www.xtractresearch.com/',
    name: 'Xtract Research',
    position: 60
  };
  var creditFlux = {
    link: 'http://www.creditflux.com/',
    name: 'Creditflux',
    position: 70
  };
  var fundsData = {
    link: '/funds-data',
    name: 'Funds Data',
    position: 75,
    newContent: true
  };
  var dockets = {
    link: '/dockets',
    name: 'Dockets',
    position: 100
  };
  var primaryIssuance = {
    hideOnSmallViewports: true,
    name: 'Primary ID',
    link: '/primary-issuance',
    isLegacy: true,
    position: 80
  };
  var restructuringDb = {
    id: '8.2048',
    name: 'Restructuring Data',
    isLegacy: false,
    link: '/restructuringdb',
    position: 90,
    hideOnSmallViewports: true
  };
  var legacyEditions = (0, _productOrEditionHomepageUrl.productOrEditionHomepageUrls)(editions, env, subscriptionTagIds).map(hideOnSmallViewports);
  return sort([homepageLink].concat(legacyEditions).concat(!(0, _collections.isEntitledOnlyToAbsMuniPrimaryIssuanceOrXtract)(editions) ? companyDirectory : []).concat([primaryIssuance, restructuringDb, dockets, xtractResearch, creditFlux, fundsData]).concat(topicsLink(editions)).map(addDisplayName));
};